
<div class="container" style="text-align: justify; background: transparent !important; margin-top: -20px; height: 220px;">
   
<!-- <div >
    <img align="center" src="../assets/img/cookieimage.png"  class="imagecookie" alt="" >
</div> -->

    <h4 class="text-center py-2">We use cookies</h4>
    <!-- <h6 class="text-center" style="color:  #1d1c1c!important; font-size: 14px; ">This BETA version of application may provide inaccurate recommendations</h6> -->

    <!-- <p>
        This is the Cookie Policy for Foodbud, accessible from <a href="https://www.foodbud.app/">www.foodbud.app</a>   
   </p> -->
  
   <p class="text_cookie">
    We use cookies to improve your experience on our webapp. You can set your preferences by selecting the options below.
    <!-- <span *ngIf="clickinfo" class="more_button" (click)="moreInfo()" >more...</span>
      <span *ngIf ="showmore">
     You can set your preferences by selecting the options below. Withdraw your consent at any time via the shield icon.
      </span> -->
   </p>
   <!-- <h5 class="text-center">What Are Cookies</h5> 
   <p>
        As is common practice with almost all professional
        websites this site uses cookies, which are tiny files
        that are downloaded to your computer, to improve your experience.
    </p>
    <a *ngIf ="clickinfo == true" style="color: blue; font-size: 14px;" (click)="moreInfo()"> Read More</a>  
<div *ngIf ="showmore == true">
    <p>This page describes what information they gather, how we use it and why we sometimes need to store these cookies. We will also share how you can prevent these cookies from being stored however this may downgrade or 'break' certain elements of the sites functionality.</p>
    <h5 class="text-center">How We Use Cookies</h5>
    <p>We use cookies for a variety of reasons detailed below. Unfortunately in most cases there are no industry
        standard options for disabling cookies without completely disabling the functionality and features they add to
        this site. It is recommended that you leave on all cookies if you are not sure whether you need them or not in
        case they are used to provide a service that you use. </p>
    <h5 class="text-center">Disabling Cookies</h5>
    <p>You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for how
        to do this). Be aware that disabling cookies will affect the functionality of this and many other websites that
        you visit. Disabling cookies will usually result in also disabling certain functionality and features of the
        this site. Therefore it is recommended that you do not disable cookies. This Cookies Policy was created with the
        help of the Cookies Policy Generator from CookiePolicyGenerator.com.</p>

<h5 class="text-center">The Cookies We Set</h5>
<ul>
    <li>
        Account related cookies
        If you create an account with us then we will use cookies for the management of the signup process and general administration. These cookies will usually be deleted when you log out however in some cases they may remain afterwards to remember your site preferences when logged out.
    </li>
    <li>
        Login related cookies
        We use cookies when you are logged in so that we can remember this fact. This prevents you from having to log in every single time you visit a new page. These cookies are typically removed or cleared when you log out to ensure that you can only access restricted features and areas when logged in.
    </li>
    <li>
        Orders processing related cookies
        This site offers e-commerce or payment facilities and some cookies are essential to ensure that your order is remembered between pages so that we can process it properly.
    </li>
    <li>
        Site preferences cookies
        In order to provide you with a great experience on this site we provide the functionality to set your preferences for how this site runs when you use it. In order to remember your preferences we need to set cookies so that this information can be called whenever you interact with a page is affected by your preferences.
    </li>
</ul>
    <h5 class="text-center">More Information</h5>
    <p>
        Hopefully that has clarified things for you and as was previously mentioned if there is something that you
        aren't sure whether you need or not it's usually safer to leave cookies enabled in case it does interact with
        one of the features you use on our site.
        For more general information on cookies, please read "What Are Cookies".
        However if you are still looking for more information then you can contact us through one of our preferred
        contact methods:
    </p> 
</div> -->


    <div class="row" style="justify-content: center; margin-top: 5%;">
        <div  class=" col-8 " align="center" >
            <button class="accep-btn" (click)="onAccept()">
                Accept All
            </button>
            <button class="accept_neccesary"  (click)="onAccept()">Accept Necessary</button>
        </div>
    </div>
    <br>
</div>

<style>
    h5 {
        color: #479943 !important;
        justify-content: center;
    }
p{
    font-family: sans-serif;
}
    button {
        background-color: #479943;
        color: #ffff;
        justify-content: center;
        align-items: center;

    }
    @media only screen and (min-width: 600px) {
            .container {
               width: 424px;
               max-width: 100%;
               
            }

        }
  
        .container {
    position: relative;
    margin-left: auto;
    margin-right: auto;
    padding-right: 11px;
    padding-left: 11px;
    margin-top: -15px;
        }
        .container p{
            font-size: 13px;
            margin-top: -10px;
        }
.imagecookie{
    width: 60px;
    height: 60px;
    border-radius: 50%;
    overflow: hidden;
    position: absolute;
    top:-30px;
    left:calc(50% - 50px);
    margin-left: 20px;
}
::ng-deep.mat-bottom-sheet-container {
    padding: 8px 16px;
    min-width: 100vw;
    box-sizing: border-box;
    display: block;
    outline: 0;
    overflow: auto;
    border-top-left-radius: 16px !important;
    border-top-right-radius: 16px !important;
}
.actions button{
    background-image: linear-gradient(to right, #43B29B,#4BAF7C,#54AC58);
    height: 30px;
    width: 180px;
    color: #ffff;
    font-weight: 500;
    border-radius: 20px;
}
.actions p{
    margin-top: 11px;
    text-align: center;
    font-size: 16px;
    color:#479943 !important;
    font-family: helvetica nue;

}
.more_button{
     color:#479943 !important;
     font-family: helvetica nue;
     font-size: 14px !important;
     font-weight: 600;

}
.text-center{
    font-size: 18px !important;
    color: #3C3C3C;
    font-weight: 700 !important;
    line-height: 23px;
    letter-spacing: 0.4px;
}
.text_cookie{
    font-family: Roboto !important;
    font-size: 14px !important;
    color: #707070;
}
.accept_neccesary{
    font-size: 14px;
    color: #62AF55;
    border: none;
    background: white;
    margin-top: 5%;
}
.accep-btn {
    background-image: linear-gradient(to right, #43B29B,#4BAF7C,#54AC58);
    height: 30px;
    width: 180px;
    color: #ffff;
    font-weight: 500;
    border-radius: 20px;
    border: none;
}
::ng-deep.mat-bottom-sheet-container-large {
    min-width: 380px;
    /* max-width: calc(51vw - 255px); */
    max-width: 380px;
}

/* ::ng-deep .mat-bottom-sheet-container-large {
        min-width: 512px;
        max-width: calc(52vw - 255px);
    } */
    ::ng-deep.mat-bottom-sheet-container-xlarge {
        /* min-width: 500px !important;
        max-width: calc(100vw - 384px); */

        min-width: 380px;
    /* max-width: calc(51vw - 255px); */
    max-width: 380px;
    }
</style>